import { injectGlobalStyles } from "@gtm-agents/gtm-ui/theme";
import { QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.js";
import { queryClient } from "./lib/queryClient.js";
import { TrpcProvider } from "./lib/trpc-provider.js";

injectGlobalStyles();

// biome-ignore lint/style/noNonNullAssertion: root element always present in index.html
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <TrpcProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </TrpcProvider>
  </React.StrictMode>,
);
